import React from "react";
import AttributeHover from "../../components/AttributeHover";
import { connect } from "react-redux";
import { hoveredOptionSelector } from "../../store/modules/configuration";

const AttributeHoverTooltip = ({ hoveredOption = null }: { hoveredOption: Object }) => {
  if (hoveredOption) {
    const hasValidImgUrl = (/\.(gif|jpg|jpeg|png)/i).test(hoveredOption.image);

    if (hoveredOption.description || hasValidImgUrl) {
      return <AttributeHover {...hoveredOption} />;
    }
  }
  return null;
};

const mapStateToProps = state => ({
  hoveredOption: hoveredOptionSelector(state)
});

export default connect(mapStateToProps)(AttributeHoverTooltip);



// WEBPACK FOOTER //
// ./src/containers/AttributeHoverToolip/index.js